import { IStringifyOptions, stringify } from 'qs'
import { useNavigate, useSearchParams } from 'react-router'

import { useLocalStorage } from '../../../hooks/useLocalStorage'

const options: IStringifyOptions = { arrayFormat: 'indices' }

export const useSetQueryParams = <T extends Record<string, any>>(key: string) => {
  const navigate = useNavigate()
  const [, setSearchParams] = useSearchParams()
  const [, setStoredQuery] = useLocalStorage(`query-params-${key}`)

  return (params: T, prefix = '') => {
    setStoredQuery(params)

    if (prefix) {
      navigate(`${prefix}?${stringify(params, options)}`)
    } else {
      setSearchParams(stringify(params, options))
    }
  }
}
